import urlsAuth from '@api/v1/urls/auth';
import urlsCurrentUser from '@api/v1/urls/current-user';
import urlsLookup from '@api/v1/urls/lookup';
import urlsShare from '@api/v1/urls/share';
import urlsTenant from '@api/v1/urls/tenant';
import urlsTenantAdmin from '@api/v1/urls/tenant-admin';
import urlsTenantUser from '@api/v1/urls/tenant-user';
import urlsUser from '@api/v1/urls/user';

const urls = Object.freeze({
  ...urlsAuth,
  ...urlsCurrentUser,
  ...urlsLookup,
  ...urlsShare,
  ...urlsTenant,
  ...urlsTenantAdmin,
  ...urlsTenantUser,
  ...urlsUser,
});

export default urls;
